export default __webpack_public_path__ + "static/media/logo.035bc9ed.png";